import { Injectable } from "@angular/core";
import { DyeSizeInterface } from "@app/models/interfaces/dye-size.interface";
import { ProductServiceInterface } from "@app/models/interfaces/product-service.interface";
import { TaqmanSearchResponseInterface } from "@app/models/responses/taqman-search-response.interface";
import { SNPProductInterface } from "@app/products/snp/models/interfaces/snp-product.interface";

@Injectable({providedIn: "root"})
export class SNPProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): SNPProductInterface[] {

        return searchResult.products.map((product) => {

            const newProduct: SNPProductInterface = {
                allele: product.allele,
                alleleFrequency: product.alleleFrequency,
                assayDesign: product.assayDesign,
                assayID: product.assayID,
                availability: product.availability,
                celerasnp: product.celerasnp,
                defaultCatalogNum: product.defaultCatalogNum,
                defaultDye: product.defaultDye,
                defaultSize: product.defaultSize,
                discontinued: product.discontinued,
                latestVersion: product.latestVersion,
                dyeSizeData: product.dyeSizeData as DyeSizeInterface[],
                gene: product.gene,
                packageId: product.packageId,
                plateSubType: product.plateSubType,
                productID: product.productID,
                productName: product.productName,
                productSubType: product.productSubType,
                productType: product.productType,
                selectedAvailability: product.availability,
                selectedCatalogNumber: product.defaultCatalogNum,
                selectedSize: product.defaultSize,
                species: product.species,
                taqmanProductID: product.productID,
                webID: product.webID, // unique ID for the UI
            }

            return newProduct;

        });

    }

}
